import { render, staticRenderFns } from "./NoteFields.vue?vue&type=template&id=15fcd1c2"
import script from "./NoteFields.vue?vue&type=script&lang=ts"
export * from "./NoteFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports